import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';
import { TextInput } from '~common/components/form/text-input.component';

interface Props {
  name: string;
  label: string;
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  shrink?: boolean;
  decimal?: boolean;
  disabled?: boolean;
}

export const NumberField: React.FunctionComponent<Props> = ({
  name,
  label,
  startAdornment,
  endAdornment,
  shrink,
  decimal,
  disabled,
  ...rest
}) => {
  return (
    <Field
      label={label}
      name={name}
      render={(renderProps): ReactNode => (
        <TextInput
          fullWidth
          type={'number'}
          InputProps={{
            startAdornment,
            endAdornment,
            inputProps: { step: decimal ? '0.01' : '1', min: '0' },
          }}
          InputLabelProps={{
            shrink: shrink,
          }}
          disabled={disabled}
          {...renderProps}
        />
      )}
      {...rest}
    />
  );
};



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/field-number.component.tsx